import React from "react";
import '../../App.css'
import DonateFormCard from "../DonateFormCard";
import Roots from "../Roots";
export default function DonateForm(){
    return (
        <>
            <DonateFormCard />
            <Roots />
        </>

    )
}